import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className='footer'>
      <div className='miscInfo'>
        <p>Active Electric Co. &#169;</p>
        <p>Tel 602.549.5052</p>
        <p>Email info@activelectric.com</p>
        <p>21419 S. 154th St.</p>
        <p>Gilbert, AZ 85298</p>
        <p>ROC 328575</p>
      </div>
    </footer>
  );
}
